(function(){
"use strict";
function safe(fn){ try{ fn(); }catch(e){  } }
var revealed=false;
function revealAll(){
if(revealed) return; revealed=true;
document.documentElement.classList.remove('js-anim');
var n=document.querySelectorAll('.rv');
for(var i=0;i<n.length;i++){ n[i].classList.add('in'); }
}
safe(function(){
if(!('IntersectionObserver' in window)) return;      // old webview: stay visible
document.documentElement.classList.add('js-anim');
var io=new IntersectionObserver(function(es){
es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
},{threshold:0.02, rootMargin:'0px 0px -5% 0px'});
document.querySelectorAll('.rv').forEach(function(e){ io.observe(e); });
setTimeout(revealAll, 2500);
window.addEventListener('load', function(){ setTimeout(revealAll, 800); });
});
safe(function(){
var sp=document.getElementById('sp'); if(!sp) return;
function calc(){
var v=+sp.value, pts=Math.floor(v*4), tier='Member', mult=1;
if(v>=6000){tier='Icon';mult=1.5} else if(v>=1750){tier='Bloom';mult=1.25}
var tp=Math.floor(pts*mult), tr=Math.floor(tp*0.0125);
document.getElementById('spv').textContent='R'+v.toLocaleString('en-ZA');
document.getElementById('o1').textContent=tp.toLocaleString('en-ZA');
document.getElementById('o2').textContent='R'+tr.toLocaleString('en-ZA');
document.getElementById('o3').textContent=tier;
}
sp.addEventListener('input',calc); calc();
});
safe(function(){
var tiles=[].slice.call(document.querySelectorAll('.tile'));
if(!tiles.length) return;
var bm=document.getElementById('bm'),bdone=document.getElementById('bdone'),bcr=document.getElementById('bcr');
function refresh(){
var on=tiles.filter(function(t){return t.classList.contains('on')});
if(bdone) bdone.textContent=on.length;
if(bm) bm.style.width=(on.length/tiles.length*100)+'%';
var bonus=0;
document.querySelectorAll('.rowtag .bonus').forEach(function(b){
var r=b.getAttribute('data-row');
var rt=tiles.filter(function(t){return t.getAttribute('data-row')===r});
var done=rt.length>0 && rt.every(function(t){return t.classList.contains('on')});
b.classList.toggle('won',done);
b.textContent=done?'Row complete, 4,000 Crowns added':'All four = 4,000 Crowns';
if(done)bonus+=4000;
});
if(on.length===tiles.length)bonus+=20000;
if(bcr) bcr.textContent=bonus.toLocaleString('en-ZA');
}
tiles.forEach(function(t){ t.addEventListener('click',function(){ t.classList.toggle('on'); refresh(); }); });
[0,1,2,3,4,8,9,12].forEach(function(i){ if(tiles[i]) tiles[i].classList.add('on'); });
refresh();
});
})();
